import { render, staticRenderFns } from "./VaultItem.vue?vue&type=template&id=bb740312"
import script from "./VaultItem.vue?vue&type=script&lang=js"
export * from "./VaultItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports